// Ajuda contextual curta: explica o que fazer no bloco atual, sem virar chat livre.

import { getCapability } from './gphCapabilityRegistry';
import { FLOW_STATES } from './gphFlowStateMachine';

const STATE_HELP = {
  [FLOW_STATES.ASKING_QUESTION]: 'Escolha uma das opções acima ou descreva com suas palavras.',
  [FLOW_STATES.COLLECTING_SKILL_INPUTS]: 'Preencha o que o bloco pede para eu montar a resposta certa.',
  [FLOW_STATES.SHOWING_FULL_SCREEN]: 'Conclua o fluxo aberto ou volte para a conversa quando quiser.',
  [FLOW_STATES.PURCHASE_REQUIRED]: 'Revise os benefícios do Pro. O pagamento acontece no checkout seguro.',
  [FLOW_STATES.FREE_LIMIT_REACHED]: 'Essa skill atingiu o limite Free. Outras skills continuam disponíveis.',
  [FLOW_STATES.SHOWING_RESULT]: 'Use os próximos passos abaixo para continuar evoluindo.',
  [FLOW_STATES.ERROR_RECOVERY]: 'Tente novamente ou comece outro problema.'
};

export const getContextualHelp = (flowState, capabilityId = null) => {
  const capability = capabilityId ? getCapability(capabilityId) : null;
  if (capability?.helpText && [
    FLOW_STATES.COLLECTING_SKILL_INPUTS,
    FLOW_STATES.MOUNTING_SKILL,
    FLOW_STATES.RUNNING_SKILL,
    FLOW_STATES.SHOWING_FULL_SCREEN,
    FLOW_STATES.SHOWING_RESULT
  ].includes(flowState)) {
    return capability.helpText;
  }
  return STATE_HELP[flowState] || null;
};

export default getContextualHelp;
